import React from "react";
import HeroImage from '../assets/hero.png'; // you can change to different images if needed

function Packages() {



  const packages = [
    {
      title: "Daily Package",
      link: "https://indosatooredoo.com/id/personal/myim3/deeplink?action=carrieroffer&offerid=REG%20AISUB1_1_LTS",
      overlayColor: "rgba(5,49,83,0.95)", // #053153
    },
    {
      title: "Weekly Package",
      link: "https://indosatooredoo.com/id/personal/myim3/deeplink?action=carrieroffer&offerid=REG%20AISUB2_1_LTS",
      overlayColor: "rgba(26,1,36,0.95)", // #1A0124
    },
    {
      title: "Monthly Package",
      link: "https://indosatooredoo.com/id/personal/myim3/deeplink?action=carrieroffer&offerid=REG%20AISUB3_1_LTS",
      overlayColor: "rgba(113,58,7,0.95)", // #713A07
    },
  ];

  const cardStyle = {
    background: `url(${HeroImage}) center/cover no-repeat`,
    position: "relative",
    color: "#fff",
    borderRadius: "8px",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "60px 20px",
  };

  const titleStyle = {
    position: "relative",
    zIndex: 2,
    marginBottom: "3rem",
    textAlign: "center",
    fontSize: "x-large",
  };

  const btnStyle = {
    position: "relative",
    zIndex: 2,
    display: "inline-block",
    padding: "0.6rem 1.5rem",
    color: "#FED501",
    border: "2px solid #FED501",
    background: "transparent",
    textDecoration: "none",
    borderRadius: "4px",
    transition: "all 0.3s ease",
  };

  return (
    <div className="container py-5">
        <div className="row mb-5 text-center">
            <div className="col-12">
                <h1 style={{ fontSize: 'x-large' }}>Choose your Package</h1>

            </div>
        </div>
      <div className="row justify-content-center">
        {packages.map((pkg) => (
          <div key={pkg.title} className="col-lg-4 col-md-6 col-12 mb-4">
            <div style={cardStyle}>
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: pkg.overlayColor,
                  zIndex: 1,
                }}
              ></div>
              <h3 style={titleStyle}>{pkg.title}</h3>
              <a
                href={pkg.link}
                style={btnStyle}
                rel="noopener noreferrer"
              >
                Subscribe
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Packages;
